import { ChildProps } from '@apollo/client/react/hoc';
import { gql } from '@apollo/client';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { AffinityBasedCmsEmbedQuery } from '@reverbdotcom/commons/src/gql/graphql';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import React from 'react';
import CmsEmbed from './cms_embed';

type SSRMode = 'off' | 'static-only' | 'full';
export interface IProps {
  slugOptionsByAffinity: Record<string, string>;
  fallback?: string;
  componentName?: string;
  ssrMode?: SSRMode;
}

type Props = ChildProps<IProps, AffinityBasedCmsEmbedQuery.Query>;

export function AffinityBasedCmsEmbed(props: Props) {
  const { data, slugOptionsByAffinity, fallback, componentName, ssrMode } = props;

  const topProductTypeUuids = data?.me?.profile?.topProductTypeUuids || [];
  const eligible = !data.loading && topProductTypeUuids.length > 0;

  // We want to fire the component view event for the experiment and control group
  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: componentName || 'AffinityBasedCmsEmbed',
  }, eligible);

  if (data.loading) return null;

  const topProductAffinity = topProductTypeUuids[0];
  const targetedCmsEmbedSlug = slugOptionsByAffinity[topProductAffinity] || fallback;

  return (
    <CmsEmbed slug={targetedCmsEmbedSlug} ssrMode={ssrMode || 'off'} />
  );
}

const withQuery = withGraphql<Props, AffinityBasedCmsEmbedQuery.Query>(
  gql`
    query Affinity_Based_Cms_Embed_Query {
      me {
        uuid
        profile {
          topProductTypeUuids
          topProductTypes
        }
      }
    }
  `,
  {
    options: ownProps => ({
      ssr: ['full', 'static-only'].includes(ownProps.ssrMode),
    }),
  },
);

export default withQuery(AffinityBasedCmsEmbed);
